import type { SVGProps } from 'react';
const SvgUnvisible = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M2.43 13.438 13.758 2.563m-7.57 9.696A6 6 0 0 0 8 12.531c2.477.042 4.99-1.697 6.537-3.407a.997.997 0 0 0 0-1.342 12 12 0 0 0-1.855-1.667m-1.607-.973A6.8 6.8 0 0 0 8 4.375c-2.417-.042-4.954 1.661-6.537 3.407a.997.997 0 0 0 0 1.342c.858.959 1.863 1.775 2.978 2.416m1.746-1.685a2.326 2.326 0 0 1 3.323-3.19m.756 1.788A2.267 2.267 0 0 1 8 10.72"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgUnvisible;
